<style>
div.user>div>div>.agent-icon-img {
  display: none;
}

.agent-icon-img {
  position: inherit;
  height: 100%;
  background-color: white;
  border-radius: 50%;
  z-index: 0;
  width: 100%;
  object-fit: cover;
}
</style>

<template>
  <div class="sendMessage">
    <div v-for="(item, key) in messages"
      :class="{ user: isType('user', item), agent: isType('agent', item), url: isType('url', item), system: isType('system', item), 'user-share-cart': isType('user_share_cart', item), 'call': isType('call', item), 'image': isType('image', item), 'file': isType(item), 'virus_detected': isType('virus_detected', item) }"
      :key="item.id">

      <div v-if="showAuthorName(key)" class="message-author"
        :class="{ 'message-user': isType('user', item), 'message-agent': isType('agent', item) }">
        <p tabindex="0" aria-live="assertive" v-if="isType('agent', item)" class="author-name"> {{ agent.name }} {{ formatTimestamp(item.created_at) }}</p>
        <p tabindex="0" aria-live="assertive" v-else-if="isType('user', item)" class="author-name"> {{ user.name ? user.name : $gettext('Yo') }} {{formatTimestamp(item.created_at) }}</p>
      </div>

      <div v-if="item.text == 'showVideoChatCallbutton()'"></div>

      <div v-else-if="isType('user_share_cart', item)" tabindex="0" aria-live="assertive" class="message-wrapper d-flex">
        <div class="d-flex">
          <div class="cart-icon"></div>
          <span class="text" v-html="$gettext('Su carrito de compra ha sido compartido con el agente.')"></span>
        </div>
      </div>

      <div v-else-if="isType('call', item)" tabindex="0" aria-live="assertive" class="acceptVideoConditions">
        <div class="header-text">
            <p>{{ $gettext('Has solicitado el servicio de videoasistencia.') }}</p>
        </div>
        <div class="start-call"> {{ formatTimestamp(item.created_at) }}</div>
        <div class="startedCall">
          <div class="cam-icon"></div>
          <div class="text-video">
            <p><strong>{{ $gettext('Videoasistencia finalizada') }}</strong></p>
            <p>{{ getDuration(item) }}</p>
          </div>
        </div>
        <br>
      </div>

      <div v-else-if="isType('system', item)" tabindex="0" aria-live="assertive" class="message-wrapper d-flex">
        <div class="info-icon"></div>
        <p class="text" v-html="item.text"></p>
      </div>

      <div v-else-if="isType('image', item)" tabindex="0" aria-live="assertive" class="message-wrapper message-wrapper--img d-flex"
        :class="{ 'message-user': item.agent_id == 0 }">
        <div class="thumbnail" @click="downloadImage(item.file_href, item.file_name)">
          <div class="image-container">
            <img v-if="getDocumentType(item?.file_name) == 'image'" :src="baseUrl + item?.file_name" alt="image"
              @error="setAltImg" />
            <img v-else src="@/assets/images/file-icon.svg" alt="File" />
          </div>
          <p class="img__details">{{ item.file_name }}</p>
        </div>
        <button v-show="item.agent_id == 0" class="delete-basket" name="deleteImage" @click="deleteImage(item.message_id)">
          <img src="@/assets/images/delete-icon.svg" alt="Delete Image" />
        </button>
      </div>


      <div v-else-if="isType('url', item)" tabindex="0" aria-live="assertive" class="message-wrapper message-wrapper--url d-flex">
        <div class="url">
          <a :href="item.text" :target="isExternalLink(item.text) ? '_blank' : '_self'" @click="handleLinkClicked">
            <div class="url-icon">
              <img src="../../src/assets/images/link.svg" alt="link" class="link-icon" />
            </div>
            {{ filterUrl(item.text) }}
          </a>

        </div>
      </div>

      <div v-else-if="isType('virus_detected', item)" aria-live="assertive" tabindex="0" class="message-wrapper d-flex"
        :class="{ lastUser: key === lastMessageOfType.user, lastAgent: key === lastMessageOfType.agent }">
        <div class="virus">
          <div class="text virus-content">
            <div>
              <img class="virus-icon" src="../../src/assets/images/incorrect.svg" alt="">
            </div>
            <div class="virus-text">
                <span class="virus-bold">{{ $gettext('No se han podido enviar los archivos') }}</span>
                <br><br>
                <span class="virus-subtitle">{{ $gettext('Hemos detectado código malicioso') }}</span>
            </div>
          </div>
          <div class="contact">
            <span>{{ $gettext('Por favor, vuelve a intentarlo o ponte en contacto con') }}</span> <br /> <a href='https://www.google.com'
              target="_blank" class="contact-link">{{ $gettext('atención al cliente') }}</a>
          </div>
        </div>
      </div>

      <div v-else-if="isType('call', item)" tabindex="0" aria-live="assertive" class="acceptVideoConditions">
        <div class="header-text">
            <p>{{ $gettext('Has solicitado el servicio de videoasistencia.') }}</p>
        </div>
        <div class="startedCall">
          <div class="cam-icon"></div>
          <div class="text-video">
            <p><strong>{{ $gettext('Videoasistencia iniciada') }}</strong></p>
            <p></p>
          </div>
        </div>
        <br>
      </div>

      <div v-else
            :style="getTextStyle(item)"
            tabindex="0"
            aria-live="assertive"
            class="message-wrapper d-flex"
        :class="{ lastUser: key === lastMessageOfType.user, lastAgent: key === lastMessageOfType.agent }">
        <p class="text"  v-html="convertUnicodeToEmoji(item.text)"></p>
      </div>
    </div>

    <div v-if="this.call" class="acceptVideoConditions" aria-live="assertive" tabindex="0">
      <div class="header-text">
        <p>{{ $gettext('Has solicitado el servicio de videoasistencia.') }}</p>
      </div>
      <div class="start-call"></div>
      <div class="startedCall">
        <div class="cam-icon"></div>
        <div class="text-video">
            <p><strong>{{ $gettext('Videollamada iniciada') }}</strong></p>
          <p v-if="this.activeVideocall">{{ getElapsedTime(this.activeVideocall.dtcreated) }}</p>
        </div>
      </div>
      <br>
    </div>

    <div v-if="!chatRated && threadState == 'closed'" tabindex="0" aria-live="assertive" style="margin-top: 20px;">
      <div class="endConversationMessage">
        <i class="success-color icon-message-confirmation"></i>
        {{ this.chatRated ?  $gettext('Gracias por tu opinión') : this.closeByInactivity ? $gettext('Conversación finalizada') : $gettext('Conversación finalizada exitosamente') }}
      </div>
      <satisfaction-poll></satisfaction-poll>
    </div>


<!--    Animación antigua -->

<!--    <div v-for="(writting, idx) in whoIsWritting" :key="writting.id" class="writtingMessage">-->
<!--      <div :class="idx" v-if="writting">-->
<!--        <div class="message-wrapper d-flex">-->
<!--          <div class="user-icon">-->
<!--            <div class="user-initial" v-if="idx == 'user'">{{ getInitial }}</div>-->
<!--          </div>-->
<!--          <div class="text">-->
<!--            <writting-animation />-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->

    <div class="acceptVideoConditions" v-if="threadState != 'closed' && this.callForm && !this.isBanned">
      <div class="header-text" tabindex="0" aria-live="assertive">
        <p>{{ $gettext('Has solicitado el servicio de videoasistencia.') }}</p>
        <p v-if="this.call">{{ $gettext('Esperando a que el agente responda') }}</p>
      </div>
      <div v-if="!this.call">
        <div class="video-condition-container"  tabindex="0">
          <div class="video-msg">
            <div class="cam-icon"></div>
            <div class="text-video">
                <strong>{{ $gettext('Tu agente te atenderá mediante llamada.') }}</strong>
                <p>{{ $gettext('Te guiará a través de la web para ayudarte de forma más rápida y sencilla.') }}</p>
            </div>
          </div>
            <p class="text-conditions">{{ $gettext('No se activará tu cámara en ningún momento. Solo el agente compartirá su imagen y pantalla para que puedas seguir los pasos cómodamente.') }}</p>
          <div class="conditions">
            <p>{{ $gettext('Al hacer clic en "Iniciar Videollamada", confirmo que he leído y acepto la ') }} <a :href="policy_url" target="_blank" rel="noopener">{{ $gettext('Política de datos') }}</a></p>
          </div>
        </div>
        <div id="call-buttons-container">
            <button class="cancel" tabindex="0" @click="cancelCall" name="cancelCall">{{ $gettext('Cancelar') }}</button>
          <button class="startCall" tabindex="0" @click="showSelectDevices" name="startCall">{{ $gettext('Iniciar Videollamada') }}</button>
        </div>
      </div>
      <br>
    </div>

    <DeviceSelector v-if="selectDevices && !this.isBanned" @closeModal="closeModal" />
  </div>
</template>
<script>
import WrittingAnimation from './WrittingAnimation.vue'
import { mapState, mapGetters, mapMutations, mapActions } from "vuex";
import defaultBackgroundUrl from '../assets/images/logoIKEA.png';
import satisfactionPoll from './SatisfactionPoll.vue'
import DeviceSelector from "@/components/VideoCall/DeviceSelector.vue";
import { getDocumentType } from '../utils';
import LinkPreview from "@ashwamegh/vue-link-preview";
import WebsiteService from "@/services/WebsiteService";


export default ({
  name: 'SendMessage',
  components: {
    WrittingAnimation,
    satisfactionPoll,
    DeviceSelector,
    LinkPreview: LinkPreview
  },
  props: ['messages'],
  data() {
    return {
      userInitial: null,
      showSatisfactionPoll: false,
      defaultBackgroundUrl,
      termsAccepted: false,
      selectDevices: false,
      timer: null
    }
  },
  methods: {
    ...mapMutations(['updateCall', 'messagesSeen', "showCallForm"]),
    ...mapActions(['sendUserFiles', 'sendCall']),
    isType(type, item) {
      return (type == 'image' && item.ikind == 11) ||
        (type == 'url' && this.isValidUrl(item.text)) ||
        (type == 'user' && item.ikind == 1) ||
        (type == 'agent' && item.ikind == 2) ||
        (type == 'system' && item.ikind == 6) ||
        (type == 'user_share_cart' && item.ikind == 10) ||
        (type == 'call' && item.ikind == 13) ||
        (type == 'virus_detected' && item.ikind == 14);
    },
    handleLinkClick(preview) {
      if (preview.url) {
        window.open(preview.url, '_blank');
      }
    },

    getDocumentType(fileName) {
      const fileExtension = fileName.split('.').pop();
      let documentType;
      if (fileExtension === 'pdf') {
        documentType = 'pdf';
      } else if (['xls', 'xlsx', 'csv'].includes(fileExtension)) {
        documentType = 'excel';
      } else {
        documentType = 'image';
      }
      return documentType;
    },
    isValidUrl(text) {
      try {
        new URL(text);
        return true;
      } catch (_) {
        return false;
      }
    },
    isExternalLink(url) {
      try {
        var localUrl = window.location.href
        var linkUrl = new URL(url, localUrl);
        return !linkUrl.host === window.location.host;
      } catch (e) {
        // Si la URL es relativa, se considera interna
        return false;
      }
    },
    handleLinkClicked(event){
      if(this.call && event.target.target == "_self" && document.querySelector('#iframeContainer')){
        event.preventDefault();
        event.stopPropagation();
        let iframe = document.querySelector('#iframeContainer').getElementsByTagName("iframe")[0]
        iframe.contentWindow.location.href = event.target.href;
      }
    },
    filterUrl(urlCompleta) {
      const url = new URL(urlCompleta);
      return `${url.protocol}//${url.host}`;
    },
    downloadImage(file_href, file_name) {
      const link = document.createElement('a');
      // baseUrl ends in "/" and file_href starts with "/": concatenating them yields "//", which prod answers with a 403.
      link.href = new URL(file_href, this.baseUrl).href;
      link.download = file_name;
      link.click();
    },
    deleteImage(id) {
      this.$confirm({
        title: this.$gettext('Eliminar imagen'),
        message: this.$gettext('¿Estás seguro de que quieres eliminar este elemento?'),
        confirmText: this.$gettext('Sí'),
        cancelText: 'No',
        button: {
          no: this.$gettext('No'),
          yes: this.$gettext('Sí')
        },

        callback: confirm => {
          if (confirm) {
            this.$store.dispatch('deleteImage', id);
          }
        }
      });
    },

    getTextStyle(item) {
      if (!this.config || !this.config.background_color) {
        return {};
      }
      const lcolor = this.lightenColor(this.config.background_color, 0.6);
      const font_color = this.config.font_color;
      return this.isType('user', item) ? { backgroundColor: lcolor, color: font_color } : {};
    },
    lightenColor(hex, factor) {
      hex = hex.replace("#", "");
      let r = parseInt(hex.substring(0, 2), 16);
      let g = parseInt(hex.substring(2, 4), 16);
      let b = parseInt(hex.substring(4, 6), 16);
      r = Math.min(255, Math.floor(r + (255 - r) * factor));
      g = Math.min(255, Math.floor(g + (255 - g) * factor));
      b = Math.min(255, Math.floor(b + (255 - b) * factor));
      const lightColor = `#${r.toString(16).padStart(2, '0')}${g.toString(16).padStart(2, '0')}${b.toString(16).padStart(2, '0')}`;
      return lightColor
    },

    parseItemDate(item) {
      return new Date(item.created_at * 1000).toLocaleTimeString().replace(/([\d]+:[\d]{2})(:[\d]{2})(.*)/, "$1$3")
    },
    setAltImg(event) {
      event.target.src = defaultBackgroundUrl;
    },
    notifyPollShown() {
      this.$emit('poll-shown');
    },
    cancelCall() {
      this.showCallForm(false);
    },
    showSelectDevices() {
      this.selectDevices = true;
    },
    closeModal() {
      this.selectDevices = false;
    },
    showAuthorName(index) {
      if (index === 0) {
        return true;
      }
      return this.isSameAuthor(index);

    },
    isSameAuthor(index) {
      const currentMessage = this.messages[index];
      const previousMessage = this.messages[index - 1];
      let currentTime = this.formatTimestamp(currentMessage.created_at)
      let previousTime = this.formatTimestamp(previousMessage.created_at)
      if ((this.isType('user', currentMessage) && !this.isType('user', previousMessage)) || currentTime > previousTime) {
        return true;
      } else if ((this.isType('agent', currentMessage) && !this.isType('agent', previousMessage)) || currentTime > previousTime) {
        return true;
      }
      return false;
    },

    formatTimestamp(timestamp) {
      const date = new Date(timestamp * 1000);
      const today = new Date();
      const isToday = date.toDateString() === today.toDateString();
      if (isToday) {
        // Si es hoy, mostrar solo la hora
        return date.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' });
      } else {
        // Si es otra fecha, mostrar fecha y hora
        return date.toLocaleDateString('en-GB') + ' ' + date.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' });
      }
    },

    getElapsedTime(createdAt) {
        const now = Date.now();
        return this.calculateTime(createdAt, now);
    },

    getDuration(item) {
      if (item.videocall && item.videocall.dtfinished) {
        const finishedAt = new Date(item.videocall.dtfinished.replace(" ", "T")).getTime();
        return this.calculateTime(item.videocall.dtcreated, finishedAt)
      }
    },

    calculateTime(createdAt, finishedAt) {
      if (createdAt && finishedAt) {
        const startTime = new Date(`${createdAt.replace(" ", "T")}Z`).getTime();
        const diffInSeconds = Math.floor((finishedAt - startTime) / 1000);
        const hours = Math.floor(diffInSeconds / 3600);
        const minutes = Math.floor((diffInSeconds % 3600) / 60);
        const seconds = diffInSeconds % 60;
        if (hours > 0) {
          return `${hours.toString().padStart(2, '0')} hr ${minutes.toString().padStart(2, '0')} min ${seconds.toString().padStart(2, '0')} seg`;
        } else if (minutes > 0) {
          return `${minutes.toString().padStart(2, '0')} min ${seconds.toString().padStart(2, '0')} seg`;
        } else {
          return `${seconds.toString().padStart(2, '0')} seg`;
        }
      }
    },
    convertUnicodeToEmoji(unicodeStr) {
      return unicodeStr.replace(/\\u([\d\w]{4})/gi, (match, grp) => {
        return String.fromCharCode(parseInt(grp, 16));
      });
    },
  },
  mounted() {
    if (this.isChatOpened) {
      this.messagesSeen();
    }
  },
  computed: {
    ...mapState(['user', 'agent', 'system', 'hasNewMessages', 'isChatOpened', 'call', 'callForm', 'isCallActive', 'activeVideocall', 'policy_url', 'isBanned']),
    ...mapGetters(['policyUrl', 'config', 'isUserLogged', "chatRated", "threadState", "baseUrl", "closeByInactivity"]),
    whoIsWritting() {
      return {
        user: this.user.isWritting,
        agent: this.agent.isWritting
      };
    },
    getInitial() {
      return this.userInitial = this.isUserLogged ? this.user.name.substring(0, 1) : "A";
    },
    lastMessageOfType() {
      var a = this.messages.map(el => el.sender ? 'user' : (el.ikind == 2 ? 'agent' : 'system'));
      var res = { agent: a.lastIndexOf('agent'), user: a.lastIndexOf('user') }
      return res;
    },
    agentAvatar() {
      return 'url( ' + this.agent.avatar + ' ) no-repeat center';
    }
  },
  watch: {
    messages(value) {
      if (this.hasNewMessages && this.isChatOpened) {
        this.messagesSeen();
      }
    },
    showSatisfactionPoll(newVal) {
      if (newVal) {
        this.notifyPollShown();
      }
    },
    activeVideocall: {
      handler(newValue) {
        if (newValue && !newValue.dtfinished) {
          // Inicia el temporizador si no está finalizada
          if (!this.timer) {
            this.timer = setInterval(() => {
              this.$forceUpdate(); // Fuerza la actualización
            }, 1000);
          }
        } else {
          // Limpia el temporizador si la videollamada ha finalizado
          if (this.timer) {
            clearInterval(this.timer);
            this.timer = null;
          }
        }
      },
      immediate: true, // Ejecuta inmediatamente cuando se carga el componente
    },

  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  }
})
</script>